import { IDB_smartDatasDelete } from '../IDB/IDB.table.smartData'
import type { SD_TReference, SD_TReferenceId } from './SD.targets'
import {
    IDB_smartDataReferencesDelete,
    IDB_smartDataReferencesReadAll,
    IDB_smartDataReferencesWrite,
} from '../IDB/IDB.table.smartDataReference'

export async function SD_deleteSmartData(
    deletions: number[],
    deps: {
        IDB_smartDataReferencesDelete: typeof IDB_smartDataReferencesDelete
        IDB_smartDataReferencesReadAll: typeof IDB_smartDataReferencesReadAll
        IDB_smartDataReferencesWrite: typeof IDB_smartDataReferencesWrite
        IDB_smartDatasDelete: typeof IDB_smartDatasDelete
    } = {
        IDB_smartDataReferencesDelete,
        IDB_smartDataReferencesReadAll,
        IDB_smartDataReferencesWrite,
        IDB_smartDatasDelete,
    }
) {
    // Early exit if there are not deletions
    if (!deletions) return
    if (deletions.length === 0) return

    // Delete the smartdata entities
    await deps.IDB_smartDatasDelete(deletions)

    // Update the references table
    const references = await deps.IDB_smartDataReferencesReadAll()
    const deletedIds = new Set(deletions)

    const toBeUpdated: SD_TReference[] = []
    const toBeDeleted: SD_TReferenceId[] = []

    references.forEach((reference) => {
        const ids = reference.ids.filter((id: number) => !deletedIds.has(id))

        if (ids.length === reference.ids.length) return

        if (ids.length > 0) {
            toBeUpdated.push({ ...reference, ids })
        } else {
            toBeDeleted.push(reference.reference)
        }
    })

    await deps.IDB_smartDataReferencesWrite(toBeUpdated)
    await deps.IDB_smartDataReferencesDelete(toBeDeleted)
}
